import { ChevronRight } from 'react-feather';
import styled from 'styled-components';

export const CollapsableSectionIcon = styled(ChevronRight)<{ $isOpen: boolean; $size?: number }>`
  height: ${({ $size = 24 }) => `${$size}px`};
  width: ${({ $size = 24 }) => `${$size}px`};
  transition: all 0.2s ease-in;
  ${({ $isOpen }) => $isOpen && `transform: rotate(90deg)`}
`;
